module.exports = __webpack_public_path__ + "static/media/wordpress.199652e4.svg";